import { render, staticRenderFns } from "./SimpleBlocks.vue?vue&type=template&id=cec2f642&"
import script from "./SimpleBlocks.vue?vue&type=script&lang=js&"
export * from "./SimpleBlocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports